{
  "achievementCenter": "成就中心",
  "achievementCenterSubtitle": "解锁徽章，赚取经验值，提升等级，建立您的 Exalt 交易所身份。",
  "badges": "徽章",
  "bearish": "看跌",
  "bullish": "看涨",
  "buy": "买入",
  "comment": "评论",
  "commentAddedSuccessfully": "评论添加成功。",
  "commentFailed": "评论添加失败。",
  "communityFeed": "社区动态",
  "communityPosts": "社区帖子",
  "completedTrades": "已完成交易",
  "copyCode": "复制代码",
  "copyLink": "复制链接",
  "createSignalPost": "发布信号/市场帖子",
  "currentLevel": "当前等级",
  "displayName": "显示名称",
  "disputes": "争议",
  "exaltTrader": "EXALT 交易者",
  "failedCreatePost": "帖子创建失败。",
  "failedLoadAchievements": "成就加载失败。",
  "failedLoadReputation": "信誉加载失败。",
  "failedLoadSocialTrading": "社交交易加载失败。",
  "failedRefreshAchievements": "成就刷新失败。",
  "failedRefreshReputation": "信誉刷新失败。",
  "follow": "关注",
  "followFailed": "关注状态更新失败。",
  "followers": "粉丝",
  "following": "关注中",
  "fraudFlags": "欺诈标记",
  "goldBadges": "金牌徽章",
  "joinExaltUsingReferral": "使用我的推荐码加入 Exalt Exchange，开始交易。",
  "joined": "加入日期",
  "levelProgress": "等级进度",
  "levelProgressText": "继续赚取经验值以达到下一等级。",
  "like": "点赞",
  "likeFailed": "点赞更新失败。",
  "loading": "加载中...",
  "loadingAchievementCenter": "成就中心加载中...",
  "loadingQr": "二维码加载中...",
  "loadingReputationCenter": "信誉中心加载中...",
  "loadingSocialTrading": "社交交易加载中...",
  "locked": "已锁定",
  "low": "低",
  "myTraderProfile": "我的交易者主页",
  "neutral": "中性",
  "noAchievementProfileFound": "未找到成就资料。",
  "noBadgesYet": "暂无徽章。",
  "noPostsYet": "暂无帖子。",
  "noReferralRewardsYet": "暂无推荐奖励。",
  "noReferredMembersYet": "您还没有推荐任何人。",
  "noReputationHistoryYet": "暂无信誉历史。",
  "noReputationProfileFound": "未找到信誉资料。",
  "noTraders": "未找到交易者。",
  "noTradersFound": "未找到交易者。",
  "p2pOrders": "P2P 订单",
  "p2pRating": "P2P 评分",
  "pair": "交易对",
  "platinum": "白金",
  "postCreatedSuccessfully": "帖子发布成功。",
  "posting": "发布中...",
  "previous": "上一页",
  "profitLoss": "盈亏",
  "publishPost": "发布帖子",
  "referralCodeCopied": "推荐码已复制。",
  "referralLinkCopied": "推荐链接已复制。",
  "referralLoadFailed": "推荐数据加载失败。",
  "referralQrCode": "推荐二维码",
  "referralReward": "推荐奖励",
  "referralRewardHistory": "推荐奖励历史",
  "referredUser": "被推荐用户",
  "refreshAchievements": "刷新成就",
  "refreshScore": "刷新评分",
  "reputationCenter": "社区信誉",
  "reputationCenterSubtitle": "通过交易信誉、P2P成功记录、认证徽章及社区活跃度，建立您的 EXALT 身份。",
  "reputationHistory": "信誉历史",
  "reputationScore": "信誉评分",
  "searchYourMembers": "按姓名或电子邮件搜索您的成员",
  "sell": "卖出",
  "send": "发送",
  "sentiment": "市场情绪",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "shareMarketViewPlaceholder": "分享市场观点、交易策略、EXALT 动态或信号...",
  "shareReferralLink": "分享推荐链接",
  "signal": "信号",
  "socialTradingSubtitle": "关注专业交易者，分享市场观点，查看信号，与 EXALT 交易社区共同成长。",
  "socialTradingTitle": "社交交易",
  "topTraders": "顶尖交易者",
  "topTradersLeaderboard": "顶尖交易者排行榜",
  "totalComments": "评论总数",
  "totalEarnings": "总收益",
  "totalLikes": "点赞总数",
  "totalReferrals": "推荐总数",
  "totalTraders": "交易者总数",
  "totalXp": "总经验值",
  "tradeType": "交易类型",
  "tradingSuccess": "交易成功率",
  "unfollow": "取消关注",
  "unlocked": "已解锁",
  "username": "用户名",
  "verified": "已认证",
  "winRate": "胜率",
  "writeBeforePosting": "发布前请输入内容。",
  "writeComment": "写下评论...",
  "yourReferralCode": "您的推荐码",
  "yourReferralLink": "您的推荐链接",
  "yourReferredMembers": "您推荐的成员"
}